(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["d911-catalogue"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('d911-photo-card')){customElements.define('d911-photo-card',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const photos=[...this.querySelectorAll('.dpc-photo')];let current=0;const change=step=>{if(photos.length<2)return;const next=(current+step+photos.length)%photos.length;const image=photos[next];if(image.dataset.src){image.src=image.dataset.src;delete image.dataset.src;}photos[current].hidden=true;image.hidden=false;current=next;this.querySelector('.dpc-photo-status').textContent=`Photo ${current+1} sur ${photos.length}`;};this.querySelector('.dpc-previous')?.addEventListener('click',()=>change(-1));this.querySelector('.dpc-next')?.addEventListener('click',()=>change(1));}});}


document.querySelectorAll('.dc-page').forEach(page=>{
const video=page.querySelector('video'),toggle=page.querySelector('.dc-video-toggle');
if(video&&toggle){toggle.addEventListener('click',()=>{if(video.paused){video.play().then(()=>toggle.textContent='Pause vidéo').catch(()=>toggle.textContent='Réessayer la vidéo')}else{video.pause();toggle.textContent='Lire la vidéo'}});if(!matchMedia('(prefers-reduced-motion: reduce)').matches)video.play().then(()=>toggle.textContent='Pause vidéo').catch(()=>{});}else if(toggle)toggle.hidden=true;
const filters=page.querySelector('.dc-filter-form');if(filters){const view=new URLSearchParams(location.search).get('view');if(view){const input=document.createElement('input');input.type='hidden';input.name='view';input.value=view;filters.append(input);}filters.addEventListener('submit',()=>filters.querySelectorAll('input,select').forEach(input=>{if(!input.value)input.disabled=true}));page.querySelector('.dc-toolbar select')?.addEventListener('change',()=>filters.requestSubmit());}
if(innerWidth<901)page.querySelector('.dc-filters').open=false;
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d911-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('d911-hero')) {
  customElements.define('d911-hero', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = {signal:this.cleanup.signal};
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let wantsPlay = !motion.matches;
      const update = () => {
        const label = video.paused ? 'Lire la vidéo' : 'Pause vidéo';
        button.textContent = label;
        button.setAttribute('aria-label', video.paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
      };
      const sync = () => {
        if (wantsPlay && !document.hidden) video.play().catch(update);
        else video.pause();
      };
      button.hidden = false;
      video.muted = true;
      button.addEventListener('click', () => {wantsPlay = video.paused;sync();}, options);
      video.addEventListener('play', update, options);
      video.addEventListener('pause', update, options);
      document.addEventListener('visibilitychange', sync, options);
      motion.addEventListener('change', () => {wantsPlay = !motion.matches;sync();}, options);
      update();sync();
    }
    disconnectedCallback() {this.cleanup?.abort();this.querySelector('video')?.pause();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d911-product-cards"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('d911-photo-card')){customElements.define('d911-photo-card',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const photos=[...this.querySelectorAll('.dpc-photo')];let current=0;const change=step=>{if(photos.length<2)return;const next=(current+step+photos.length)%photos.length;const image=photos[next];if(image.dataset.src){image.src=image.dataset.src;delete image.dataset.src;}photos[current].hidden=true;image.hidden=false;current=next;this.querySelector('.dpc-photo-status').textContent=`Photo ${current+1} sur ${photos.length}`;};this.querySelector('.dpc-previous')?.addEventListener('click',()=>change(-1));this.querySelector('.dpc-next')?.addEventListener('click',()=>change(1));}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // ── Hide the main ATC block on Soumission products ──
  // The _product-details block renders its own ATC button outside our Liquid scope.
  // We add a body class and target it with CSS, and also inject the replacement button
  // adjacent to the native ATC button for best placement.
  (function () {
    const isSoumission = document.querySelector('sticky-add-to-cart[data-is-soumission="true"]');
    if (!isSoumission) return;

    function injectReplacementButton() {
      // Scope to product section only — never the header or cart drawer
      const productScope = document.querySelector(
        '.product-information, [data-section-type="product"], #shopify-section-product-information, main'
      );
      if (!productScope) return;

      const atcSelectors = [
        '.product-form__submit',
        'button[name="add"]',
        '.product-form__buttons',
        '.product-form [type="submit"]'
      ];

      let atcContainer = null;
      for (const sel of atcSelectors) {
        const el = productScope.querySelector(sel); // scoped — never matches header
        if (el) {
          atcContainer = el.closest('.product-form__buttons') || el.parentElement;
          break;
        }
      }

      if (atcContainer && !atcContainer.querySelector('.soumission-btn-inline')) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'button button--primary soumission-btn soumission-btn-inline';
        btn.style.width = '100%';
        btn.style.marginTop = '0';
        btn.textContent = 'Demander un prix';
        btn.addEventListener('click', function () {
          document.getElementById('soumission-modal').showModal();
        });
        atcContainer.appendChild(btn);
      }
    }

    // Run after DOM is ready; retry briefly for deferred renders
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectReplacementButton);
    } else {
      injectReplacementButton();
    }

    // Also handle variant-change re-renders
    document.addEventListener('variant:change', injectReplacementButton);

    // Close modal on backdrop click
    const modal = document.getElementById('soumission-modal');
    if (modal) {
      modal.addEventListener('click', function (e) {
        const rect = modal.getBoundingClientRect();
        if (
          e.clientX < rect.left || e.clientX > rect.right ||
          e.clientY < rect.top  || e.clientY > rect.bottom
        ) {
          modal.close();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
